module.exports = __webpack_public_path__ + "img/ssyx_28.3f1fcb9e.jpg";